import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	//<BrowserRouter style={{ scrollBehavior: 'smooth' }}  basename="/civilconsultancyservice">
	//<BrowserRouter style={{ scrollBehavior: 'smooth' }}>
	<BrowserRouter style={{ scrollBehavior: 'smooth' }}  basename="/civilconsultancyservice">
    <App />
  </BrowserRouter>
);

reportWebVitals();
